<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../static/img/logo/logo-white.png"></navbar>
      <div class="st-FixedPoint"></div>

      <div class="st-MainContainer">

        <main class="st-MainContents">

          <div class="top-Mv">
            <div class="top-Mv_Slide swiper-container swiper-container-fade swiper-container-initialized swiper-container-horizontal">
              <div class="swiper-wrapper">
                <div class="swiper-slide top-Mv_Slide-item" data-swiper-autoplay="5000" data-swiper-slide-index="0">
                  <a href="javascript:void(0)">
                    <div class="top-Mv_Slide-image">
                      <div class="top-Mv_Slide-image-sp">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/home/home1.jpg) 50%/cover no-repeat;">
                        </div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/home/home1.jpg) 50%/cover no-repeat;">
                        </div>
                      </div>
                      <div class="top-Mv_Slide-image-pc">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/home/home1.jpg) 50%/cover no-repeat;">
                        </div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/home/home1.jpg) 50%/cover no-repeat;">
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="swiper-slide top-Mv_Slide-item" data-swiper-autoplay="5000" data-swiper-slide-index="1">
                  <a href="javascript:void(0)">
                    <div class="top-Mv_Slide-image">
                      <div class="top-Mv_Slide-image-sp">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/home/home2.jpg) 50%/cover no-repeat;">
                        </div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/home/home2.jpg) 50%/cover no-repeat;">
                        </div>
                      </div>
                      <div class="top-Mv_Slide-image-pc">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/home/home2.jpg) 50%/cover no-repeat;">
                        </div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/home/home2.jpg) 50%/cover no-repeat;">
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
                <div class="swiper-slide top-Mv_Slide-item" data-swiper-autoplay="5000" data-swiper-slide-index="2">
                  <a href="javascript:void(0)">
                    <div class="top-Mv_Slide-image">
                      <div class="top-Mv_Slide-image-sp">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/home/home3.jpg) 50%/cover no-repeat;">
                        </div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/home/home3.jpg) 50%/cover no-repeat;">
                        </div>
                      </div>
                      <div class="top-Mv_Slide-image-pc">
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image1" style="background: url(../../../static/img/home/home3.jpg) 50%/cover no-repeat;">
                        </div>
                        <div class="company-PageTitle_Slide-image company-PageTitle_Slide-image-image2" style="background: url(../../../static/img/home/home3.jpg) 50%/cover no-repeat;">
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
              <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets">
                <span @click="swiperPagination($event,0)" class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide 1">
                  <div class="circle"><svg viewBox="0 0 124 124">
                      <circle style="animation-duration:5000ms" cx="62" cy="62" r="60"></circle>
                    </svg></div>
                </span>
                <span @click="swiperPagination($event,1)" class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 2">
                  <div class="circle"><svg viewBox="0 0 124 124">
                      <circle style="animation-duration:5000ms" cx="62" cy="62" r="60"></circle>
                    </svg></div>
                </span>
                <span @click="swiperPagination($event,2)" class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide 3">
                  <div class="circle"><svg viewBox="0 0 124 124">
                      <circle style="animation-duration:5000ms" cx="62" cy="62" r="60"></circle>
                    </svg></div>
                </span>
              </div>
              <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span>
            </div>
          </div>
          <section class="top-card st-Grid" style="background-color: #fff;">

            <div class="container-row-warp p-0">
              <div class="st-Grid_Inner st-Grid_Inner_appear p-0">
                <h2 class="sw-Section_Header home-compyany-appear-1" data-appear="true">
                  <span class="sw-Section_Header-en"><b>
                      <font>
                        <font>COMPYANY</font>
                      </font>
                    </b></span>
                  <span class="sw-Section_Header-ja"><b>
                      <font>
                        <font>企業情報</font>
                      </font>
                    </b></span>
                </h2>
              </div>

              <div class="row col-12 p-md-0 m-0 common-appear home-compyany-appear-2" data-appear="true">

                <div class="col-md-4 text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
                    <defs>
                      <clipPath id="compyany-svg-image1">
                        <path fill="none" transform="rotate(0 23 23)" d="M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"></path>
                      </clipPath>
                    </defs>
                    <image clip-path="url(#compyany-svg-image1)" height="100%" width="100%" href="../../../static/img/home/home-12.jpg"></image>
                    <path fill="none" stroke="white" stroke-width="0" transform="rotate(0 23 23)" opacity=".5" d="M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"></path>
                  </svg>
                  <div class="text-left">
                    <h1><img src="../../../static/img/home/dx.png" width="60" height="60" />会社概要</h1>
                    <div class="bt_more">
                      <router-link class="bt_more_a" to="/company/profile">会社概要</router-link>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 text-center show-pc">
                  <div class="text-left">
                    <br />
                    <h1><img src="../../../static/img/home/ky.png" width="60" height="60" />サービス案内</h1>
                    <div class="bt_more">
                      <router-link class="bt_more_a" to="/service/index">サービス案内</router-link>
                    </div>
                  </div>
                  <br /><br />
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
                    <defs>
                      <clipPath id="compyany-svg-image2-1">
                        <path fill="none" transform="rotate(0 23 23)" d="M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"></path>
                      </clipPath>
                    </defs>
                    <image clip-path="url(#compyany-svg-image2-1)" height="100%" width="100%" href="../../../static/img/home/home-11.jpg"></image>
                    <path fill="none" stroke="white" stroke-width="0" transform="rotate(0 23 23)" opacity=".5" d="M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"></path>
                  </svg>
                </div>

                <div class="col-md-4 text-center show-sp">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
                    <defs>
                      <clipPath id="compyany-svg-image2-2">
                        <path fill="none" transform="rotate(0 23 23)" d="M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"></path>
                      </clipPath>
                    </defs>
                    <image clip-path="url(#compyany-svg-image2-2)" height="100%" width="100%" href="../../../static/img/home/home-11.jpg"></image>
                    <path fill="none" stroke="white" stroke-width="0" transform="rotate(0 23 23)" opacity=".5" d="M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"></path>
                  </svg>
                  <div class="text-left">
                    <br />
                    <h1><img src="../../../static/img/home/ky.png" width="60" height="60" />サービス案内</h1>
                    <div class="bt_more">
                      <router-link class="bt_more_a" to="/service/index">サービス案内</router-link>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 text-center">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
                    <defs>
                      <clipPath id="compyany-svg-image3">
                        <path fill="none" transform="rotate(0 23 23)" d="M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"></path>
                      </clipPath>
                    </defs>
                    <image clip-path="url(#compyany-svg-image3)" height="100%" width="100%" href="../../../static/img/home/home-13.jpg"></image>
                    <path fill="none" stroke="white" stroke-width="0" transform="rotate(0 23 23)" opacity=".5" d="M31 3.5a5 5 90 014 3l8 14a5 5 90 010 5l-8 14a5 5 90 01-4 3h-16a5 5 90 01-4-3l-8-14a5 5 90 010-5l8-14a5 5 90 014-3z"></path>
                  </svg>
                  <div class="text-left">
                    <h1><img src="../../../static/img/home/sm.png" width="60" height="60" />ソリューションズ</h1>
                    <div class="bt_more">
                      <router-link class="bt_more_a" to="/solution/logistics-automation">ソリューションズ</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './copyright'
import navbar from './navbar'
import Swiper from 'swiper/swiper-bundle.js'
import 'swiper/swiper-bundle.css'
import newsList from '../../../static/js/news-list.js'

export default {
  components: { copyright, navbar },
  data: function () {
    return {
      mySwiper: '',
      mySwiperNews: '',
      newsList: newsList
    }
  },
  mounted() {
    this.init()
  },
  methods: {

    swiperPagination(event, index) {
      this.mySwiper.slideTo(index + 1)
    },
    init() {

      new Swiper('.swiper-container-home-fast', {
        pagination: {
          el: '.swiper-pagination-fast',
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          769: {
            slidesPerView: 'auto',
            spaceBetween: 20
          },
        },
        loop: true,
        autoplay: true,
      })

      new Swiper('.swiper-container-home-report', {
        pagination: {
          el: '.swiper-pagination-report',
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          769: {
            slidesPerView: 'auto',
            spaceBetween: 20
          },
        },
        loop: true,
        autoplay: true,
      })

      let mySwiperNewsSettings = {
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.swiper-button-next-home-news',
          prevEl: '.swiper-button-prev-home-news'
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0
          },
          769: {
            slidesPerView: 4,
            spaceBetween: 50
          },
        }
      }
      this.mySwiperNews = new Swiper('.swiper-container-home-news', mySwiperNewsSettings)

      this.mySwiper = new Swiper('.top-Mv_Slide', {
        autoplay: {
          disableOnInteraction: false
        },
        loop: true,
        effect: 'fade',
        on: {
          slideChangeTransitionStart: function (event) {
            $('.swiper-pagination-bullet').removeClass('swiper-pagination-bullet-active')
            $($('.swiper-pagination-bullet')[event.realIndex]).addClass('swiper-pagination-bullet-active')
          }
        }
      })

      $('.home-compyany-appear-1').addClass('appear')
      $('.home-compyany-appear-1').parent().addClass('st-Grid_Inner_appear')
      $('.home-compyany-appear-2').addClass('appear')

      $(document).scroll(() => {

        if (this.$route.path != '/') {
          return false
        }

        let scroH = $(document).scrollTop()
        let viewW = $(window).width()
        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Hd_Logo a img').attr('src', '../../../static/img/logo/logo-black.png')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Hd_Logo a img').attr('src', '../../../static/img/logo/logo-white.png')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (viewW > 769) {
          if (scroH > 800) {
            $('.home-compyany-appear-1').removeClass('appear')
            $('.home-compyany-appear-1').parent().removeClass('st-Grid_Inner_appear')
          } else {
            $('.home-compyany-appear-1').addClass('appear')
            $('.home-compyany-appear-1').parent().addClass('st-Grid_Inner_appear')
          }

          if (scroH > 1350) {
            $('.home-compyany-appear-2').removeClass('appear')
          } else {
            $('.home-compyany-appear-2').addClass('appear')
          }

        } else {
          $('.home-compyany-appear-1').addClass('appear')
          $('.home-compyany-appear-1').parent().addClass('st-Grid_Inner_appear')
          $('.home-compyany-appear-2').addClass('appear')
        }
      })
    }
  }
}
</script>
<style scoped src="../../../static/css/home.css">
</style>



// WEBPACK FOOTER //
// src/components/pages/home.vue